

import * as React from 'react'

import "./headder.scss"
import logo from "./logo.png"

export function Headder({deconnexion}) {
    return (
        <div className="main-headder">
            <img src={logo} width="200" height="125" alt="logo"/>
            <h1>Database MasterTool</h1>
            <button onClick={deconnexion} >Déconnexion</button>

        </div>
    )
}
